import React, { useState } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import BitaSpinner from '../../../../../components/BitaSpinner/BitaSpinner';
import TableList from './tableList/TableList';
import styles from '../updateBasket.module.scss';
import { HEADER_LIST } from '../../../utils/constants';

const BasketTable = ({
  allBasketsList,
  setCheckedBasketsIds,
  checkedBasketsIds,
  handleDownloadTemplate,
  isLoadingDownloadTemplate,
  handleEdit,
  isLoadingBasketData,
  handleClearSelection,
}) => {
  const [showList, setShowList] = useState(true);

  return (
    <div className={styles.pageContainer}>
      <div className={styles.sectionTitle}>BASKET LIST</div>
      <div className={styles.subSection}>
        <button className={styles.downloadCenterButton} onClick={() => setShowList(!showList)}>
          {showList ? 'Hide Baskets' : 'Show Baskets'}
        </button>
      </div>
      {showList && (
        <div style={{ width: '100%', paddingTop: '40px' }}>
          {allBasketsList?.length === 0 ? (
            <BitaSpinner />
          ) : (
            <TableList
              headers={HEADER_LIST}
              data={allBasketsList}
              onChangeSelect={value => {
                setCheckedBasketsIds(value);
              }}
              checkedBasketsIds={checkedBasketsIds}
              selectedBasketsCount={checkedBasketsIds?.length}
              handleClearSelection={handleClearSelection}
            />
          )}
        </div>
      )}
      {showList && (
        <div className={styles.subSection}>
          <button
            className={styles.downloadCenterButton}
            onClick={handleDownloadTemplate}
            disabled={isLoadingDownloadTemplate}
          >
            {isLoadingDownloadTemplate ? (
              <ClipLoader size={16} color="#fff" />
            ) : (
              'Download Template'
            )}
          </button>
          <button
            className={styles.downloadCenterButton}
            onClick={handleEdit}
            disabled={isLoadingBasketData || checkedBasketsIds?.length === 0}
          >
            {isLoadingBasketData ? <ClipLoader size={16} color="#fff" /> : 'Edit Baskets'}
          </button>
        </div>
      )}
    </div>
  );
};

export default BasketTable;
